import React, { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";
import { VscSearch, VscMenu, VscChevronRight, VscFilePdf } from "react-icons/vsc";
import { Link } from "react-scroll";

const tabs = [
  { link: "about", file: "about.md", dot: "bg-syntax-fn" },
  { link: "skills", file: "package.json", dot: "bg-syntax-num" },
  { link: "work", file: "experience.log", dot: "bg-term-green" },
  { link: "projects", file: "projects/", dot: "bg-syntax-prop" },
  { link: "contact", file: "contact.sh", dot: "bg-syntax-key" },
];

const NavBar = () => {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = nav ? "hidden" : "auto";
  }, [nav]);

  return (
    <header
      className={`fixed top-0 z-50 w-full border-b transition-all duration-300 ${
        scrolled
          ? "border-editor-border bg-editor-panel/90 backdrop-blur-md"
          : "border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-2.5 text-sm">
        {/* Traffic lights + breadcrumb */}
        <Link
          to="home"
          smooth
          duration={500}
          className="flex cursor-pointer items-center gap-3"
        >
          <span className="dots">
            <span className="bg-light-red" />
            <span className="bg-light-amber" />
            <span className="bg-light-green" />
          </span>
          <span className="hidden items-center gap-1.5 text-syntax-comment sm:flex">
            <span className="text-syntax-str">~/khubayb</span>
            <VscChevronRight className="text-gutter" />
            <span>portfolio</span>
          </span>
        </Link>

        {/* File tabs */}
        <ul className="hidden items-center gap-0.5 lg:flex">
          {tabs.map(({ link, file, dot }) => (
            <li key={link}>
              <Link
                to={link}
                smooth
                offset={-70}
                duration={500}
                className="group flex cursor-pointer items-center gap-2 rounded-md border border-transparent px-3 py-1.5 text-syntax-comment transition-colors hover:border-editor-border hover:bg-editor-elevated hover:text-zinc-200"
              >
                <span className={`h-1.5 w-1.5 rounded-full ${dot} opacity-60 group-hover:opacity-100`} />
                {file}
              </Link>
            </li>
          ))}
          <li>
            <a
              href="KhubaybKapilaCV.pdf"
              download
              className="ml-2 flex items-center gap-2 rounded-md border border-editor-border bg-editor-elevated px-3 py-1.5 text-zinc-300 transition-colors hover:border-syntax-fn hover:text-white"
            >
              <VscFilePdf className="text-syntax-tag" />
              resume.pdf
            </a>
          </li>
        </ul>

        {/* Mobile trigger — looks like a command-palette hint */}
        <button
          onClick={() => setNav(true)}
          className="flex items-center gap-2 rounded-md border border-editor-border bg-editor-elevated px-3 py-1.5 text-syntax-comment lg:hidden"
          aria-label="Open command palette"
        >
          <VscSearch size={14} />
          <span className="text-xs">Go to…</span>
          <VscMenu size={14} />
        </button>
      </nav>

      {/* Command palette overlay */}
      {nav && (
        <div className="fixed inset-0 flex items-start justify-center bg-editor-inset/80 px-4 pt-24 backdrop-blur-sm">
          <div className="w-full max-w-md overflow-hidden rounded-lg border border-editor-border bg-editor-panel shadow-2xl">
            <div className="flex items-center gap-2 border-b border-editor-border px-4 py-3">
              <VscChevronRight className="text-term-green" />
              <span className="flex-1 text-syntax-comment">go to section…</span>
              <button onClick={() => setNav(false)} aria-label="Close">
                <FaTimes className="text-syntax-comment hover:text-white" />
              </button>
            </div>
            <ul className="p-2">
              {tabs.map(({ link, file, dot }) => (
                <li key={link}>
                  <Link
                    onClick={() => setNav(false)}
                    to={link}
                    smooth
                    offset={-70}
                    duration={500}
                    className="flex cursor-pointer items-center gap-3 rounded-md px-3 py-2.5 text-zinc-300 transition-colors hover:bg-editor-elevated"
                  >
                    <span className={`h-2 w-2 rounded-full ${dot}`} />
                    {file}
                  </Link>
                </li>
              ))}
              <li className="mt-1 border-t border-editor-border pt-1">
                <a
                  href="KhubaybKapilaCV.pdf"
                  download
                  onClick={() => setNav(false)}
                  className="flex items-center gap-3 rounded-md px-3 py-2.5 text-zinc-300 transition-colors hover:bg-editor-elevated"
                >
                  <VscFilePdf className="text-syntax-tag" />
                  download resume.pdf
                </a>
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavBar;
